var bpfrpt_proptype_ScrollIndices = process.env.NODE_ENV === 'production' ? null : {
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};
import PropTypes from "prop-types";
export { bpfrpt_proptype_ScrollIndices };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-virtualized/dist/es/ArrowKeyStepper/types.js
// module id = 260
// module chunks = 0